/*
 *
 * ImportGpx constants
 *
 */

export const GPX_UPLOAD = 'app/ImportGpx/GPX_UPLOAD';
export const GPX_UPLOAD_SUCCESS = 'app/ImportGpx/GPX_UPLOAD_SUCCESS';
export const GPX_UPLOAD_ERROR = 'app/ImportGpx/GPX_UPLOAD_ERROR';
